import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import BrandValuesModuleContainer from 'containers/BrandValuesModuleContainer';

const BrandValuesModuleController = class {
  static renderBrandValuesModule = store => {
    const domElement = document.getElementById('brand-values-module-container');

    if (domElement) {
      ReactDOM.render(
        <Provider store={store}>
          <BrandValuesModuleContainer />
        </Provider>,
        domElement
      );
    }
  };

  static init = store => {
    BrandValuesModuleController.renderBrandValuesModule(store);
  };
};

export default BrandValuesModuleController;
